import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef, memo } from "react";
import { InfiniteScrollSpinner } from "~/components/InfiniteScroll/InfiniteScrollSpinner";
import { KANBAN_COLUMN, KANBAN_COLUMN_SPINNER } from "~/constants/testIDs";
/** BoxProps are excluded from type def to avoid passing additional props from parents using KanbanColumnProps */ export const KanbanColumnContainer = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef(// we get the props just fine, TS, ref and all
// eslint-disable-next-line react/prop-types
(param, ref)=>{
    let { children, header, isLoading, variant } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex h-full flex-col rounded-lg border border-grey-5 bg-grey-1 pb-2 transition-all", (variant === "activeDropzone" || variant === "activeDropzoneWithChildren") && "border-blue-10 bg-blue-1", variant === "withDragOverlay" && "hidden"),
        ref: ref,
        "data-testid": KANBAN_COLUMN,
        children: [
            header,
            isLoading && /*#__PURE__*/ _jsx(InfiniteScrollSpinner, {
                dataTestId: KANBAN_COLUMN_SPINNER
            }),
            children
        ]
    });
}));
KanbanColumnContainer.displayName = "KanbanColumnContainer";
